export class VersionService {
    version:string = "1434";

    getVersion(): string {
        return this.version;
    }
}
